module.exports = "/_next/static/images/7f440ba356dc49300bdadc77ba0e5759-10-million.svg.webp";